module.exports = __webpack_public_path__ + "img/play.47f1d475.svg";